import React from 'react'
import { Box, Button } from '@chakra-ui/react'
import { FaFile } from 'react-icons/fa'

import FileChooser from '../includes/FileChooser'
import PrivateFile from '../includes/PrivateFile'

export default function File ({ dataType, value, onChange, participant }) {
  return (
    <Box>
      {!value?.fileName &&
        <FileChooser
          accept='.doc,.docx,application/msword,.pdf,.xls,.xlsx,.ppt,.pptx,.pages,.numbers,.key,.txt'
          forType='participant' forObject={participant}
          onComplete={({ storedName, name }) => onChange({ name, fileName: storedName })}
          trigger={<Button size='sm' variant='outline' colorScheme='primary'><Box as={FaFile} mr={2} /> Choose a file</Button>}
        />}
      {value?.fileName &&
        <PrivateFile forType='participant' forObject={participant} name={value.fileName} displayName={value.name} onRemove={() => onChange('')} />}
    </Box>
  )
}
